// extracted by mini-css-extract-plugin
export default {"root":"zVbWPPw6jQ","item":"kglJX4_p2R","button":"KBeXnXRgDZ","title":"suS5e9IqQL"};